module.exports = __webpack_public_path__ + "img/product_17.b87d1c3.jpg";